import { createContext } from "react";
import { WidgetControlsContextType } from "./types";

const defaultContextValue = {
    state:  undefined,
    dispatch: undefined
}
export const WidgetControlsContext = 
    createContext<WidgetControlsContextType>(defaultContextValue);